import Switch from "./Switch";
import useStoredFormValue from "../../hooks/useStoredFormValue";

function Question({ id, readOnly, showErrorForMissingField }) {
  const { dataType, value: defaultValue, groupId, groupMinimumRequired, ...rest } = useStoredFormValue({
    questionId: id
  })
  
  if(!dataType) {
    return false
  }

  return <Switch showErrorForMissingField={showErrorForMissingField} readOnly={readOnly} dataType={dataType} {...rest} defaultValue={defaultValue} />;
}
export default Question;
